
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

const DatePicker = ({ value, setIsDate, handleDateChange, disabled }) => {
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['StaticDatePicker']}>
                    <DemoItem>
                        <StaticDatePicker
                            value={value ? dayjs(value) : dayjs()}
                            onChange={handleDateChange}
                            shouldDisableDate={(date) => {
                                return date.isSame(disabled && dayjs(disabled), 'day') ||
                                    date.isBefore(disabled ? dayjs(disabled) : dayjs(), 'day');
                            }}
                            slotProps={{
                                actionBar: {
                                    actions: []
                                }
                            }}
                            sx={{
                                '& .MuiPickersDay-root.Mui-selected': {
                                    backgroundColor: '#4038ff !important',
                                },
                                '& .MuiPickersDay-root.MuiPickersDay-today': {
                                    border: '2px solid #4038ff',
                                },
                                '& .MuiPickersToolbar-root': {
                                    backgroundColor: '#4038ff !important',
                                    color : 'white !important'
                                },
                                '& .MuiTypography-root' : {
                                    color : 'white !important'
                                }
                            }}
                        />
                        <div style={{margin : 0}} className="bg-white flex items-center justify-end p-2">
                            <button onClick={() => setIsDate(false)} className='px-[8px] py-[6px] text-blue-500 w-[70px]'>CANCEL</button>
                            <button onClick={() => { setIsDate(false); !value && handleDateChange(dayjs()) }} className='px-[8px] py-[6px] text-blue-500 w-[70px]'>OK</button>
                        </div>
                    </DemoItem>
                </DemoContainer>
            </LocalizationProvider>
        </div>
    )
}

export default DatePicker